<div class="modal custom-modal show" style="display: block;">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Build Versions</h5>
                <button type="button" class="close" (click)="onClose()">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div *ngIf="isLoading" class="text-center p-3">
                    <i class="fa fa-spinner fa-spin"></i> Loading...
                </div>

                <div class="table-responsive" *ngIf="!isLoading">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Version</th>
                                <th>Date</th>
                                <th>Email</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let v of versions;" (click)="onSelect(v)" class="version-row"
                                title="Click to load this version">
                                <td>{{ v.version }}</td>
                                <td>{{ v.created_at | date:'short' }}</td>
                                <td>{{ v.email }}</td>
                                <td>
                                    <button class="btn btn-sm btn-outline-info" (click)="onViewDiff(v.version, $event)"
                                        *ngIf="v.rebase == false && v.version > 0 ">
                                        Diff
                                    </button>

                                    <button class="btn btn-sm btn-outline-info" [class.live]="v.published"
                                        [disabled]="v.published" (click)="publish(v.id, $event)" *ngIf="v.version > 0">
                                        {{ v.published ? 'LIVE' : 'Publish' }}
                                    </button>
                                </td>
                            </tr>
                            <tr *ngIf="versions.length === 0">
                                <td colspan="3" class="text-center">No versions found.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onClose()">Close</button>
            </div>
        </div>
    </div>
</div>
<!-- Backdrop for visual isolation -->
<div class="modal-backdrop show"></div>